import {
  FETCH_BUZZ,
  FETCH_BUZZ_SUCCESS,
  FETCH_BUZZ_ERROR,
  ADD_BUZZ,
  ADD_BUZZ_SUCCESS,
  ADD_BUZZ_ERROR,
  RESET_ADD_BUZZ,
  UPDATE_BUZZ,
  UPDATE_BUZZ_SUCCESS,
  UPDATE_BUZZ_ERROR,
  DELETE_BUZZ,
  DELETE_BUZZ_SUCCESS,
  DELETE_BUZZ_ERROR,
} from "constants/ActionTypes";

export const fetchBuzz = (params) => {
  return {
    type: FETCH_BUZZ,
    params,
  }
};

export const fetchBuzzSuccess = (buzzList) => {
  return {
    type: FETCH_BUZZ_SUCCESS,
    payload: buzzList,
  }
};

export const fetchBuzzError = (error) => {
  return {
    type: FETCH_BUZZ_ERROR,
    payload: error
  }
};

export const addBuzz = (payload) => {
  return {
    type: ADD_BUZZ,
    payload,
  }
};

export const addBuzzSuccess = (payload) => {
  return {
    type: ADD_BUZZ_SUCCESS,
    payload,
  }
};

export const addBuzzError = (error) => {
  return {
    type: ADD_BUZZ_ERROR,
    payload: error
  }
};

export const updateBuzz = (payload) => {
  return {
    type: UPDATE_BUZZ,
    payload,
  }
};

export const updateBuzzSuccess = (payload) => {
  return {
    type: UPDATE_BUZZ_SUCCESS,
    payload,
  }
};

export const updateBuzzError = (error) => {
  return {
    type: UPDATE_BUZZ_ERROR,
    payload: error
  }
};

export const deleteBuzz = (payload) => {
  return {
    type: DELETE_BUZZ,
    payload,
  }
};

export const deleteBuzzSuccess = (payload) => {
  return {
    type: DELETE_BUZZ_SUCCESS,
    payload,
  }
};

export const deleteBuzzError = (error) => {
  return {
    type: DELETE_BUZZ_ERROR,
    payload: error
  }
};

export const resetAddBuzz = () => {
  return {
    type: RESET_ADD_BUZZ,
  }
};
